/**
 * Video Players Module
 * Initializes Plyr video players with German translations
 */

// @ts-expect-error - Plyr types don't match ES module export correctly
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';
import '../../css/components/plyr-custom.css';

/**
 * Vollbild-Einstellungen fuer alle Player.
 * iosNative: Das iPhone unterstuetzt die Fullscreen-API nur direkt am <video>-Element.
 * Ohne diese Option faellt Plyr dort auf ein CSS-"Pseudo-Vollbild" zurueck,
 * bei dem die Safari-Leisten sichtbar bleiben. Mit iosNative oeffnet sich der native iOS-Player.
 */
export const FULLSCREEN_OPTIONS = {
  enabled: true,
  fallback: true,
  iosNative: true
};

/**
 * Querformat-Videos im Vollbild auf Android im Querformat einrasten lassen,
 * damit man das Handy nicht drehen muss. (iOS regelt das im nativen Player selbst.)
 */
export function lockLandscapeInFullscreen(player: any): void {
  const orientation = screen.orientation as any;
  if (!orientation?.lock) return;

  player.on('enterfullscreen', () => {
    const video = player.media as HTMLVideoElement;
    if (video.videoWidth >= video.videoHeight) {
      orientation.lock('landscape').catch(() => { /* nicht unterstuetzt (z. B. Desktop) */ });
    }
  });

  player.on('exitfullscreen', () => {
    try {
      orientation.unlock();
    } catch {
      /* nicht unterstuetzt */
    }
  });
}

export function initVideoPlayers(): void {
  const videoElements = document.querySelectorAll<HTMLVideoElement>('video');

  if (videoElements.length === 0) {
    return;
  }

  videoElements.forEach(video => {
    const player = new Plyr(video, {
      fullscreen: FULLSCREEN_OPTIONS,
      controls: [
        'play-large',
        'play',
        'progress',
        'current-time',
        'mute',
        'volume',
        'fullscreen'
      ],
      i18n: {
        restart: 'Neustart',
        play: 'Abspielen',
        pause: 'Pause',
        fastForward: 'Vorspulen {seektime}s',
        rewind: 'Zurückspulen {seektime}s',
        seek: 'Suchen',
        seekLabel: '{currentTime} von {duration}',
        played: 'Abgespielt',
        buffered: 'Gepuffert',
        currentTime: 'Aktuelle Zeit',
        duration: 'Dauer',
        volume: 'Lautstärke',
        mute: 'Stumm',
        unmute: 'Ton an',
        enableCaptions: 'Untertitel aktivieren',
        disableCaptions: 'Untertitel deaktivieren',
        download: 'Herunterladen',
        enterFullscreen: 'Vollbild',
        exitFullscreen: 'Vollbild beenden',
        frameTitle: 'Player für {title}',
        captions: 'Untertitel',
        settings: 'Einstellungen',
        menuBack: 'Zurück',
        speed: 'Geschwindigkeit',
        normal: 'Normal',
        quality: 'Qualität',
        loop: 'Schleife'
      }
    });

    lockLandscapeInFullscreen(player);
  });
}
